var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewNotificationWithBadgeMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,36c0,1.6542969-1.3457031,3-3,3H7c-1.6542969,0-3-1.3457031-3-3V12c0-1.6542969,1.3457031-3,3-3h31V7H7 c-2.7568359,0-5,2.2431641-5,5v24c0,2.7568359,2.2431641,5,5,5h34c2.7568359,0,5-2.2431641,5-5V15h-2V36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    width: 32,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 23,
    width: 32,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 29,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,5c-2.2060547,0-4,1.7944336-4,4s1.7939453,4,4,4s4-1.7944336,4-4S46.2060547,5,44,5z M44,11 c-1.1025391,0-2-0.8969727-2-2s0.8974609-2,2-2s2,0.8969727,2,2S45.1025391,11,44,11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotificationWithBadgeMedium);
export default __webpack_public_path__ + "static/media/new-notification-with-badge--medium.96a05dcf27f367f26c46876837b2200e.svg";
export { ForwardRef as ReactComponent };